module.exports = __webpack_public_path__ + "static/media/icon.966dd434.png";